<script>
  import { onMount, afterUpdate } from 'svelte';
  export let content;
  export let family;
  export let style;
  export let size = 72;
  export let lineHeight = 1.1;
  export let allStyles;
  export let allFamilies;

  let letterSpacing = 0;
  let focused = false;
  let winWidth = 0;

  let align = 'left';
  let currentContent = content;
  let currentStyle = style;
  let currentFamily = family;
  let currentSize = size;
  let currentLineHeight = lineHeight;
  let manualSize = false;
  
  let innerHTML = `<span>${currentContent}</span>`

  let contentEl = null;
  let wrapperEl = null;
  let testerEl = null;

  const styles = allStyles.split(',');
  const families = allFamilies.split(',');

  let useMultiColumn = content.split(' ').length > 2;

  function fitText() {
    if (useMultiColumn || manualSize) return;

    if (contentEl && wrapperEl) {
      contentEl.style.overflow = 'hidden';
      currentSize = Math.floor(
        (wrapperEl.offsetWidth / contentEl.scrollWidth) * parseInt(currentSize)
      );
      contentEl.style.overflow = 'visible';
    }
  }

  function reset() {
    currentContent = content;
    currentStyle = style;
    currentSize = size;
    currentLineHeight = lineHeight;
    align = 'left';
    letterSpacing = 0;
    manualSize = false;
  }

  function interceptPaste(e) {
    e.preventDefault();
    const text = (e.originalEvent || e).clipboardData.getData('text/plain');
    document.execCommand('insertHTML', false, text);
  }

  onMount(() => {
    document.fonts.ready.then(function () {
      fitText();
    });
  });

  afterUpdate(() => {
    if (!manualSize) {
      fitText();
    }
  });

  function onBlur(node) {
    const handleBlur = (event) => {
      if (document.activeElement.closest('.wrapper') !== testerEl) {
        focused = false;
      }
    };

    node.addEventListener('blur', handleBlur);

    return {
      destroy() {
        node.removeEventListener('blur', handleBlur);
      },
    };
  }

  function onFocus(node) {
    const handleFocus = (event) => {
      focused = true;
    };

    node.addEventListener('focus', handleFocus);

    return {
      destroy() {
        node.removeEventListener('focus', handleFocus);
      },
    };
  }
</script>

<svelte:window
  bind:innerWidth={winWidth}
  on:resize={fitText}
  on:orientationchange={fitText}
/>
<div class="wrapper" class:focused bind:this={testerEl}>
  <div class="controls">
    <div class="control-group font-size">
      <p style="flex: 0 0 50px;">{currentSize}px</p>
      <input
        class="font-size"
        type="range"
        min="10"
        max="400"
        on:input={() => {
          manualSize = true;
        }}
        use:onFocus
        use:onBlur
        bind:value={currentSize}
      />
      {#if families.length > 1 && winWidth > 600}
        <form class="family">
          <select bind:value={currentFamily} use:onFocus use:onBlur>
            {#each families as fontFamily}
              <option value={fontFamily} selected={fontFamily === currentFamily}
                >{fontFamily}</option
              >
            {/each}
          </select>
          <span>{currentFamily}</span>
          <i class="chevron" />
        </form>
      {/if}
      <form class="style">
        <select bind:value={currentStyle} use:onFocus use:onBlur>
          {#each styles as fontStyle}
            <option value={fontStyle} selected={fontStyle === currentStyle}
              >{fontStyle}</option
            >
          {/each}
        </select>
        <span>{currentStyle}</span>
        <i class="chevron" />
      </form>
    </div>

    <div class="control-group line-height">
      <input
        class="line-height hidden-mobile"
        type="range"
        min="0.8"
        max="3"
        step="0.1"
        bind:value={currentLineHeight}
        use:onFocus
        use:onBlur
      />
      <p class="label-line-height hidden-mobile">{currentLineHeight}</p>
    </div>

    <div class="control-group letter-spacing">
      <input
        class="letter-spacing hidden-mobile"
        type="range"
        min="-0.1"
        max="0.2"
        step="0.001"
        bind:value={letterSpacing}
        on:input={() => {
          manualSize = true;
        }}
        use:onFocus
        use:onBlur
      />
      <p style="flex: 0 0 60px;" class="label-letter-spacing hidden-mobile">
        {letterSpacing}
      </p>
    </div>
    <div class="control-group alignment">
      <button
        title="Align left"
        class="align align-left hidden-mobile"
        class:active={align === 'left'}
        use:onFocus
        use:onBlur
        on:click={() => {
          align = 'left';
        }}>Left align</button
      >
      <button
        title="Align center"
        class="align align-center hidden-mobile"
        class:active={align === 'center'}
        use:onFocus
        use:onBlur
        on:click={() => {
          align = 'center';
        }}>Center align</button
      >
      <button
        title="Reset editor"
        class="reset"
        use:onFocus
        use:onBlur
        on:click={reset}>Reset</button
      >
    </div>
  </div>
  <div
    bind:this={wrapperEl}
    class="content-wrapper"
    lang="en"
    style="font-family: {currentFamily} {currentStyle}; font-size: {currentSize}px; line-height: {currentLineHeight}; letter-spacing: {letterSpacing}em; text-align: {align};"
  >
    <p
      bind:this={contentEl}
      class:columns={useMultiColumn}
      contenteditable
      autocomplete="off"
      autocorrect="off"
      autocapitalize="off"
      spellcheck="false"
      on:paste={interceptPaste}
      bind:innerHTML={innerHTML}
      style="font-size: {currentSize}px"
      class:manual-size={manualSize === true || useMultiColumn}
      use:onFocus
      use:onBlur
      on:keydown={() => {
        manualSize = true;
      }}
    />
  </div>
</div>

<style>
  .wrapper {
    width: 100%;
    position: relative;
    white-space: nowrap;
    margin-bottom: 40px;
  }

  /* input.font-size,
  .control-group.line-height,
  .control-group.letter-spacing,
  .control-group.alignment {
    opacity: 0;
    pointer-events: none;
  }

  .focused input.font-size,
  .focused .control-group.line-height,
  .focused .control-group.letter-spacing,
  .focused .control-group.alignment {
    opacity: 1;
    pointer-events: all;
  } */

  .font-size input[type='range'] {
    width: 200px;
    max-width: calc(25vw - 20px);
  }

  .line-height input[type='range'],
  .letter-spacing input[type='range'] {
    width: 100px;
  }

  .controls {
    display: flex;
    width: 100%;
    max-width: 100%;
    align-items: center;
    justify-content: space-between;
  }

  .controls > * {
    flex: 0;
  }

  .controls p {
    margin: 0 16px 0 0;
    width: 50px;
    display: inline-block;
    flex-basis: 50px;
  }

  .controls :disabled {
    visibility: hidden;
  }

  .control-group {
    display: flex;
    align-items: center;
  }

  .control-group > * {
    flex-shrink: 1;
  }

  .label-letter-spacing {
    flex: 0 0 75px;
    padding-left: 25px;
    background-image: url("data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M14 12V3' stroke='black' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M18 12V3' stroke='black' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M10 12V3' stroke='black' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M6 12V3' stroke='black' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M17.7427 17.8019C17.8727 17.902 17.8727 18.098 17.7427 18.1981L13.9025 21.1543C13.7381 21.2808 13.5 21.1636 13.5 20.9562V15.0438C13.5 14.8364 13.7381 14.7192 13.9025 14.8457L17.7427 17.8019Z' fill='black'/%3E%3Cpath d='M6.25734 18.1981C6.12734 18.098 6.12734 17.902 6.25734 17.8019L10.0975 14.8457C10.2619 14.7192 10.5 14.8364 10.5 15.0438V20.9562C10.5 21.1636 10.2619 21.2808 10.0975 21.1543L6.25734 18.1981Z' fill='black'/%3E%3C/svg%3E%0A");
    background-size: contain;
    background-position: center left;
    background-repeat: no-repeat;
  }

  .label-line-height {
    flex: 0 0 75px;
    padding-left: 25px;
    background-image: url("data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M10 10H3' stroke='black' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M12 6H3' stroke='black' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M12 14H3' stroke='black' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M10 18H3' stroke='black' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M17.8019 6.25734C17.902 6.12734 18.098 6.12734 18.1981 6.25734L21.1543 10.0975C21.2808 10.2619 21.1636 10.5 20.9562 10.5H15.0438C14.8364 10.5 14.7192 10.2619 14.8457 10.0975L17.8019 6.25734Z' fill='black'/%3E%3Cpath d='M18.1981 17.7427C18.098 17.8727 17.902 17.8727 17.8019 17.7427L14.8457 13.9025C14.7192 13.7381 14.8364 13.5 15.0438 13.5H20.9562C21.1636 13.5 21.2808 13.7381 21.1543 13.9025L18.1981 17.7427Z' fill='black'/%3E%3C/svg%3E%0A");
    background-size: contain;
    background-position: center left;
    background-repeat: no-repeat;
  }

  .align,
  .reset {
    border: none;
    background-color: none;
    box-shadow: none;
    opacity: 0.5;
    background-size: 24px 24px;
    background-repeat: no-repeat;
    background-position: center center;
    font-size: 0px;
    overflow: hidden;
    text-indent: 100%;
    width: 32px;
    height: 32px;
    line-height: 24px;
  }

  .align.active {
    opacity: 1;
  }

  .align-left {
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' width='24' height='24' stroke='currentColor' stroke-width='2' fill='none' stroke-linecap='round' stroke-linejoin='round' class='css-i6dzq1'%3E%3Cline x1='17' y1='10' x2='3' y2='10'%3E%3C/line%3E%3Cline x1='21' y1='6' x2='3' y2='6'%3E%3C/line%3E%3Cline x1='21' y1='14' x2='3' y2='14'%3E%3C/line%3E%3Cline x1='17' y1='18' x2='3' y2='18'%3E%3C/line%3E%3C/svg%3E");
  }

  .align-center {
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' width='24' height='24' stroke='currentColor' stroke-width='2' fill='none' stroke-linecap='round' stroke-linejoin='round' class='css-i6dzq1'%3E%3Cline x1='18' y1='10' x2='6' y2='10'%3E%3C/line%3E%3Cline x1='21' y1='6' x2='3' y2='6'%3E%3C/line%3E%3Cline x1='21' y1='14' x2='3' y2='14'%3E%3C/line%3E%3Cline x1='18' y1='18' x2='6' y2='18'%3E%3C/line%3E%3C/svg%3E");
  }

  .reset {
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' class='ionicon' viewBox='0 0 512 512'%3E%3Ctitle%3ERefresh%3C/title%3E%3Cpath d='M320 146s24.36-12-64-12a160 160 0 10160 160' fill='none' stroke='currentColor' stroke-linecap='round' stroke-miterlimit='10' stroke-width='32'/%3E%3Cpath fill='none' stroke='currentColor' stroke-linecap='round' stroke-linejoin='round' stroke-width='32' d='M256 58l80 80-80 80'/%3E%3C/svg%3E");
    opacity: 1;
  }

  form {
    position: relative;
    margin-right: 16px;
  }

  form span {
    visibility: hidden;
    padding-right: 32px;
    display: inline-block;
  }

  select {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none; /* Remove default arrow */
    background: transparent;
    border: none;
    box-shadow: none;
    width: auto;
    display: block;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    color: #222;
  }

  i.chevron {
    height: 25px;
    width: 25px;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' width='24' height='24' stroke='currentColor' stroke-width='2' fill='none' stroke-linecap='round' stroke-linejoin='round' class='css-i6dzq1'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E");
    background-position: 50% 60%;
    background-repeat: no-repeat;
    background-size: 80%;
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    pointer-events: none;
  }

  input {
    position: relative;
    z-index: 100;
  }

  input[type='range'] {
    height: 18px;
    -webkit-appearance: none;
    margin: 0 16px 0 0;
    width: 100%;
    max-width: 300px;
    background-color: var(--spring-wood);
  }

  input.letter-spacing {
    max-width: 100px;
  }

  input[type='range']:focus {
    outline: none;
  }
  input[type='range']::-webkit-slider-runnable-track {
    width: 100%;
    height: 1px;
    cursor: pointer;
    animate: 0.2s;
    box-shadow: 0px 0px 0px #000000;
    background: #000000;
    border-radius: 5px;
    border: 0px solid #000000;
  }
  input[type='range']::-webkit-slider-thumb {
    box-shadow: 0px 0px 0px #000000;
    border: 1px solid #000;
    height: 18px;
    width: 18px;
    border-radius: 25px;
    background: var(--spring-wood);
    cursor: pointer;
    -webkit-appearance: none;
    margin-top: -9px;
  }
  input[type='range']:focus::-webkit-slider-runnable-track {
    background: #000000;
  }
  input[type='range']::-moz-range-track {
    width: 100%;
    height: 1px;
    cursor: pointer;
    animate: 0.2s;
    box-shadow: 0px 0px 0px #000000;
    background: #000000;
    border-radius: 5px;
    border: 0px solid #000000;
  }
  input[type='range']::-moz-range-thumb {
    box-shadow: 0px 0px 0px #000000;
    border: 1px solid #000;
    height: 18px;
    width: 18px;
    border-radius: 25px;
    background: var(--spring-wood);
    cursor: pointer;
  }
  input[type='range']::-ms-track {
    width: 100%;
    height: 1px;
    cursor: pointer;
    animate: 0.2s;
    background: transparent;
    border-color: transparent;
    color: transparent;
  }
  input[type='range']::-ms-fill-lower {
    background: #000000;
    border: 0px solid #000000;
    border-radius: 10px;
    box-shadow: 0px 0px 0px #000000;
  }
  input[type='range']::-ms-fill-upper {
    background: #000000;
    border: 0px solid #000000;
    border-radius: 10px;
    box-shadow: 0px 0px 0px #000000;
  }
  input[type='range']::-ms-thumb {
    margin-top: 1px;
    box-shadow: 0px 0px 0px #000000;
    border: 1px solid #000;
    height: 18px;
    width: 18px;
    border-radius: 25px;
    background: var(--spring-wood);
    cursor: pointer;
  }
  input[type='range']:focus::-ms-fill-lower {
    background: #000000;
  }
  input[type='range']:focus::-ms-fill-upper {
    background: #000000;
  }

  [contenteditable] {
    padding: 0.1em 0;
    border: none;
    border-radius: 0;
    outline: none;
    /* overflow: hidden; */
    margin-bottom: 0;
    display: inline-block;
    white-space: nowrap;
  }

  p.columns {
    padding: 16px 0;
    column-count: auto;
    column-width: 40ch;
    margin-left: -0.4ch;
  }

  p.columns :global(span) {
    padding-left: 0.4ch;
    display: block;
  }

  select,
  button {
    cursor: pointer;
  }

  [contenteditable].manual-size {
    display: block !important;
    white-space: normal !important;
    word-wrap: break-word !important;
    overflow-wrap: break-word;
    -webkit-hyphens: auto;
    -moz-hyphens: auto;
    -ms-hyphens: auto;
    hyphens: auto;
    overflow: visible !important;
  }

  @media screen and (max-width: 1024px) {
    .hidden-mobile {
      display: none !important;
    }
  }
</style>
